import { useLocation } from "react-router-dom";
import styles from "./Footer.module.css";

export const CONTAINER_CLASS =
  "w-full px-4 sm:px-6 md:px-8 grid grid-cols-12 gap-3 sm:gap-4";

export const CONTAINER_CONTENT_CLASS = "col-span-12";

export function Footer() {
  return (
    <footer className="w-full bg-header text-header-foreground border-t border-header-foreground/20">
      <div className={CONTAINER_CLASS}>
        <div
          className={`${CONTAINER_CONTENT_CLASS} flex flex-col gap-3 py-6 sm:py-8 text-center`}
        >
          <p className="text-sm text-header-foreground/80">
            Desenvolvido pela GETI da Defensoria Pública do Estado de Santa
            Catarina.
          </p>
          <p className="text-sm text-header-foreground/80">
            Endereço: Av. Rio Branco, nº 919, Ed. Centro Executivo Rio Branco,
            Centro, Florianópolis/SC, 88015-205
          </p>
          <p className="text-sm text-header-foreground/80">
            Contato: (48) 3665-6370 / (48) 3665-6589 / (48) 3665-6654
          </p>
        </div>
      </div>
    </footer>
  );
}